import { computed } from '@ember/object';
import BillingItemMixin from 'client-portal/mixins/polymorphic/billing-item';
import Model, { attr, hasMany } from '@ember-data/model';

export default class SuperbillModel extends Model.extend(BillingItemMixin) {
  @hasMany('appointment', { async: false, inverse: 'superbill' }) appointments;
  @attr() displayName;
  @attr('moment') createdAt;
  @attr() totalAmount;
  @attr() isNewForClient;

  @computed('isNewForClient', 'opened')
  get isUnread() {
    return !this.opened && this.isNewForClient;
  }

  opened = false;
}
